import React from 'react';
import './Loader.scss';

const Loader = (props) => {
  return (
    <div className={'Loader ' + props.className} data-testid="Loader">
      {/*<span>*/}
      {/*  <i className="spinner" />*/}
      {/*</span>*/}

      <div className="vertical-centered-box">
        <div className="content">
          <div className="loader-circle" />
          <div className="loader-line-mask">
            <div className="loader-line" />
          </div>
          <svg width="88" height="30" viewBox="0 0 88 30" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M28.519 6.55124C25.2283 2.02919 22.1652 0.116211 15.68 0.116211C6.5776 0.116211 0 6.28909 0 14.9825C0 23.6759 6.5776 29.8506 15.68 29.8506C22.0355 29.8506 26.3974 27.679 29.1959 22.335L25.8591 19.9846C23.9224 23.5059 21.6713 26.0281 16.579 26.0281C10.4527 26.0281 8.92648 19.8535 8.92648 14.8125C8.92648 9.77139 10.4545 3.51351 16.579 3.51351C21.0405 3.51351 22.7516 6.16333 25.0489 9.07705L28.519 6.55302V6.55124Z" fill="white"/>
            <path d="M33.581 30L36.6051 21.296H47.0649L50.4727 30H60.1579L48.552 0H39.8192L29.0715 30H33.581ZM41.5924 6.807H41.6919L45.6701 17.2256H38.0442L41.5924 6.807Z" fill="white"/>
            <path d="M71.0157 13.7982V4.07747H73.704C76.9662 4.07747 78.9848 5.97273 78.9848 9.16814C78.9848 11.9897 77.3479 13.7982 74.0398 13.7982H71.0157ZM71.0157 30V17.8721H77.9202C82.9145 17.8721 88 15.8334 88 9.6747C88 3.51597 83.1514 0 76.5329 0H62.2865V30H71.0157Z" fill="white"/>
          </svg>
        </div>
      </div>
    </div>
  )
};

Loader.propTypes = {};

export default Loader;
